import React from 'react'
import {
  CardContainer,
  ContentContainer,
  HeaderContainer,
  Title,
  Subtitle,
  InfoContainer,
  InfoText,
  ButtonsContainer,
  SecondaryButton,
  PrimaryButton,
  SingleButton
} from './styles'
import { AuthorizationStatus, RecurrenceStatus } from 'store/debin/types'

interface DebinCardProps {
  company: string
  sellerTaxId: string
  date: string
  amount: string
  installments: number
  concept: string
  status: RecurrenceStatus
  authorizationStatus: AuthorizationStatus
  onReject: () => void
  onConfirm: () => void
  onView: () => void
}

const DebinCard: React.FC<DebinCardProps> = ({
  company,
  sellerTaxId,
  date,
  amount,
  installments,
  concept,
  status,
  authorizationStatus,
  onReject,
  onConfirm,
  onView
}) => {
  return (
    <CardContainer>
      <ContentContainer>
        <HeaderContainer>
          <Title>Debin Programado</Title>
          <Subtitle>
            {sellerTaxId}
            {' / '}
            {company}
          </Subtitle>
        </HeaderContainer>

        <InfoContainer>
          <InfoText>
            {`Fecha: ${date}`}
            {'\n'}
            {`Monto total de la operación: $${amount}`}
            {'\n'}
            {`Cuotas: ${installments}`}
            {'\n'}
            {`Concepto: ${concept}`}
          </InfoText>
        </InfoContainer>

        {status === RecurrenceStatus.INACTIVE && authorizationStatus === AuthorizationStatus.PENDING
          ? (
            <ButtonsContainer>
              <SecondaryButton onClick={onReject}>
                Rechazar
              </SecondaryButton>
              <PrimaryButton onClick={onConfirm}>
                Aceptar
              </PrimaryButton>
            </ButtonsContainer>
            )
          : (
            <ButtonsContainer>
              <SingleButton onClick={onView}>
                Ver DEBIN
              </SingleButton>
            </ButtonsContainer>
            )}
      </ContentContainer>
    </CardContainer>
  )
}

export default DebinCard
